import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import ProfileCard from "./ProfileCard";

export default function SpotlightRow() {
  return (
    <div className="relative">
      <Carousel opts={{ align: "start" }}>
        <CarouselContent>
          {Array.from({ length: 8 }).map((_, i) => (
            <CarouselItem key={i} className="basis-2/3 sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
              <ProfileCard />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </div>
  );
}
